export default `<div>
    <select class="hidden" multiple tabindex="-1"></select>
    <div class="multi-select-container">
        <div class="multi-select-input-wrapper">
            <div class="multi-select-input-container">
                <div class="selected-options"></div>
                <input
                    type="text"
                    class="multi-select-input"
                    autocomplete="off"
                    spellcheck="false"
                    role="combobox"
                    aria-autocomplete="list"
                    aria-expanded="false"
                    aria-haspopup="listbox"
                />
                <button class="dropdown-btn" tabindex="-1" aria-hidden="true">
                    <svg
                        class="dropdown-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M1.37429 0.49997C1.48718 0.499885 1.59916 0.521371 1.70401 0.563357C1.80877 0.605307 1.90516 0.66725 1.98713 0.746566L6.99965 5.58166L12.0125 0.746252C12.1779 0.586701 12.3985 0.500118 12.6249 0.500118C12.8513 0.500118 13.0719 0.586687 13.2373 0.746253C13.4033 0.906412 13.5 1.12753 13.5 1.36199C13.5 1.5965 13.4033 1.81758 13.2373 1.97771L7.87728 7.14798C7.64162 7.37526 7.32569 7.49997 6.9999 7.49997C6.67409 7.49997 6.35822 7.37528 6.12256 7.14802L0.762542 1.97772C0.639047 1.85844 0.552584 1.70409 0.517467 1.53356C0.482326 1.36291 0.50055 1.18623 0.569057 1.02662C0.637457 0.867263 0.752006 0.73394 0.895404 0.641406C1.03674 0.550202 1.20302 0.500115 1.37429 0.49997Z"
                            fill="currentColor"
                        />
                    </svg>
                </button>
            </div>
            <label class="floating-label">Select options</label>
        </div>
        <div class="multi-select-dropdown">
            <svea-dropdown-content>
                <svea-datalist multiple></svea-datalist>
            </svea-dropdown-content>
        </div>
    </div>
    <div
        class="multi-select-live-region sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
    ></div>
</div>

<style>
    :host {
        display: block;
        position: relative;
        width: 100%;
        font-family: Asap, sans-serif;
    }

    .hidden {
        display: none;
    }

    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }

    .multi-select-container {
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .multi-select-input-wrapper {
        position: relative;
        cursor: text;
    }

    .multi-select-input-wrapper {
        position: relative;
        cursor: text;
    }

    .multi-select-input-wrapper:has(.multi-select-input-container.disabled) {
        pointer-events: none;
    }

    .multi-select-input-wrapper .selected-options {
        cursor: text;
    }

    .multi-select-input-container {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        position: relative;
        min-height: var(--svea-input-height, 3.5rem);
        padding: 1rem 2.5rem 0rem 1.25rem;
        border: var(--svea-input-border, 1px solid #949494);
        border-radius: 0.5rem;
        background-color: var(--svea-input-background, #ffffff);
        cursor: text;
        box-sizing: border-box;
        column-gap: 0.5rem;
    }

    .multi-select-input-container.disabled {
        background-color: var(--svea-input-disabled-background, #f6f6f1);
        color: var(--svea-input-disabled-color, #949494);
    }

    .multi-select-input-container.has-options {
        min-height: 4.25rem;
    }

    .multi-select-input-container.has-options:not(:has(.active)) {
        padding-bottom: 0.5rem;
    }

    .multi-select-input-container:hover {
        border-color: var(--svea-input-border-color-hover, #146790);
    }

    .multi-select-input-container:focus-within {
        outline: var(--svea-input-outline, 2px solid #115475);
        outline-offset: -2px;
        border-color: transparent;
    }

    .multi-select-input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.5rem;
        color: var(--svea-input-color, #434343);
        background: transparent;
        padding: 0;
        padding-top: 0.5rem;
        margin: 0;
        caret-color: #00aece;
        position: absolute;
        left: -9999px;
        opacity: 0;
        pointer-events: none;
    }

    .multi-select-input.has-text,
    .multi-select-input-container.active .multi-select-input {
        opacity: 1;
        pointer-events: auto;
        left: 0;
        right: 0;
        width: 100%;
        position: relative;
    }

    .multi-select-input-container.has-options {
        padding-top: 1.75rem;
    }

    .multi-select-input-container.has-options .multi-select-input {
        padding-top: 0.25rem;
    }

    .selected-options {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        align-items: center;
        pointer-events: all;
        cursor: default;
    }

    .selected-options:empty {
        display: none;
    }

    .selected-options svea-pill {
        margin: 0;
        pointer-events: all;
        cursor: default;
        z-index: 2;
    }

    .dropdown-btn {
        position: absolute;
        background: none;
        border: none;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: var(--svea-input-button-color, #00699a);
    }

    .dropdown-icon {
        transition: transform 0.2s ease-in-out;
        pointer-events: none;
    }

    .multi-select-input-container.disabled .dropdown-icon {
        color: var(--svea-input-disabled-button-color, #cbcbcb);
    }

    .multi-select-container.open .dropdown-icon {
        transform: translateY(-50%) rotate(180deg);
    }

    .floating-label {
        position: absolute;
        left: 1.25rem;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1rem;
        color: var(--svea-input-label-color, #434343);
        pointer-events: none;
        transition: all 0.2s ease-in-out;
        background-color: var(--svea-input-label-background, transparent);
        padding: 0;
        z-index: 1;
    }

    .multi-select-input-container.disabled + .floating-label {
        color: var(--svea-input-disabled-color, #949494);
    }

    .floating-label.active,
    .multi-select-input-container:focus-within + .floating-label,
    .multi-select-input-container.has-value + .floating-label,
    .multi-select-input-container.has-options + .floating-label {
        top: 1rem;
        font-size: 0.75rem;
        line-height: 1rem;
        transform: translateY(-50%);
    }

    .multi-select-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 1000;
        width: 100%;
    }

    svea-pill::part(pill) {
        --svea-pill-border: 1px solid #949494;
    }
</style>
`